import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from './Constants';

function AdminHomePage({ clickChangeMenu }) {
    const [stats, setStats] = useState({
        newsCount: 0,
        videoCount: 0,
        audioCount: 0,
        bookCount: 0,
        trafficTotal: 0,
        trafficToday: 0,
        trafficYesterday: 0,
        trafficOnline: 0,
        visitsPerDayInMonth: [],
        visitsPerMonthInYear: []
    });
    const [loading, setLoading] = useState(true);
    const [hoveredDay, setHoveredDay] = useState(null);
    const [hoveredMonth, setHoveredMonth] = useState(null);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                // Adjust Axios base URL or interceptors depending on the actual app configured setup
                // Assuming standard Bearer token is needed:
                const token = localStorage.getItem('token');
                const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};

                // Assuming the backend is hosted at the react app's proxy or same domain
                const res = await axios.get(`${API_URL}/dashboard/stats`, config);
                if (res.data) {
                    setStats(res.data);
                }
            } catch (err) {
                console.error("Error fetching dashboard stats:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, []);

    const maxMonthValue = Math.max(...(stats.visitsPerMonthInYear?.length ? stats.visitsPerMonthInYear.map(d => d.value) : [1]), 1);
    const maxDayValue = Math.max(...(stats.visitsPerDayInMonth?.length ? stats.visitsPerDayInMonth.map(d => d.value) : [1]), 1);

    return (
        <div className="container-fluid">
            <div className="row-fluid">
                <div className="span12">
                    <h3 className="page-title">
                        Trang chính
                    </h3>
                </div>
            </div>
            <div className="row-fluid">
                <div>
                    <section className="social-box social-bordered social-blue">
                        <div className="header">
                            <h4>Thêm nhanh</h4>
                        </div>
                        <div className="body">
                            <a className="btn btn-primary" href="#" onClick={(e) => { e.preventDefault(); clickChangeMenu('tintuc-create') }}>Tạo Tin tức</a>
                            <a className="btn btn-primary" href="#" onClick={(e) => { e.preventDefault(); clickChangeMenu('video-create') }}>Tạo Video</a>
                            <a className="btn btn-primary" href="#" onClick={(e) => { e.preventDefault(); clickChangeMenu('audio-create') }}>Tạo Audio</a>
                            <a className="btn btn-primary" href="#" onClick={(e) => { e.preventDefault(); clickChangeMenu('kinhsach-create') }}>Tạo Kinh sách</a>
                            <a className="btn btn-primary" href="#" onClick={(e) => { e.preventDefault(); clickChangeMenu('slideshowheader-create') }}>Tạo SlideShow Header</a>
                            <a className="btn btn-primary" href="#" onClick={(e) => { e.preventDefault(); clickChangeMenu('sachnoi-create') }}>Tạo Sách nói</a>
                        </div>
                    </section>
                </div>
                <section className="social-box social-bordered">
                    <div className="header">
                        <h4>Thống kê</h4>
                    </div>
                    <div className="body">
                        <table className="table stat-cards">
                            <thead>
                                <tr>
                                    <th>Loại nội dung</th>
                                    <th>Số lượng</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Tin tức</td>
                                    <td>{loading ? '...' : stats.newsCount}</td>
                                </tr>
                                <tr>
                                    <td>Video</td>
                                    <td>{loading ? '...' : stats.videoCount}</td>
                                </tr>
                                <tr>
                                    <td>Audio</td>
                                    <td>{loading ? '...' : stats.audioCount}</td>
                                </tr>
                                <tr>
                                    <td>Kinh sách</td>
                                    <td>{loading ? '...' : stats.bookCount}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
            <div className="row-fluid">
                <div className="span12">
                    <section className="social-box social-bordered">
                        <header className="header">
                            <h4><i className="icon-bar-chart" />Thống kê truy cập</h4>
                        </header>
                        <div className="body" style={{ padding: '15px' }}>
                            <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                                <li style={{ marginBottom: '8px' }}>
                                    • Đang truy cập <strong>{loading ? '...' : stats.trafficOnline}</strong>
                                </li>
                                <li style={{ marginBottom: '8px' }}>
                                    • Hôm nay <strong>{loading ? '...' : stats.trafficToday}</strong>
                                </li>
                                <li style={{ marginBottom: '8px' }}>
                                    • Hôm qua <strong>{loading ? '...' : stats.trafficYesterday}</strong>
                                </li>
                                <li style={{ marginBottom: '8px' }}>
                                    • Tổng truy cập <strong>{loading ? '...' : stats.trafficTotal.toLocaleString('vi-VN')}</strong>
                                </li>
                            </ul>
                        </div>
                    </section>
                </div>
            </div>
            <div className="row-fluid">
                <div className="span6">
                    <section className="social-box social-bordered">
                        <header className="header">
                            <h4><i className="icon-bar-chart" /> Biểu đồ theo ngày</h4>
                        </header>
                        <div className="body" style={{ padding: '15px', overflowX: 'auto' }}>
                            <div style={{ height: '250px', display: 'flex', alignItems: 'flex-end', gap: '2px', minWidth: '400px' }}>
                                {stats.visitsPerDayInMonth && stats.visitsPerDayInMonth.map(item => (
                                    <div
                                        key={item.label}
                                        onMouseEnter={() => setHoveredDay(item.label)}
                                        onMouseLeave={() => setHoveredDay(null)}
                                        style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', position: 'relative' }}
                                    >
                                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', width: '100%', position: 'relative' }} title={`Ngày ${item.label}: ${item.value}`}>
                                            {hoveredDay === item.label && (
                                                <div style={{
                                                    position: 'absolute',
                                                    bottom: `${(item.value / maxDayValue) * 100}%`,
                                                    width: '100%',
                                                    textAlign: 'center',
                                                    fontSize: '10px',
                                                    fontWeight: 'bold',
                                                    marginBottom: '2px',
                                                    color: '#5bb75b',
                                                    pointerEvents: 'none'
                                                }}>
                                                    {item.value}
                                                </div>
                                            )}
                                            <div style={{ height: `${(item.value / maxDayValue) * 100}%`, width: '100%', backgroundColor: '#5bb75b', minHeight: '1px' }}></div>
                                        </div>
                                        <span style={{ fontSize: '9px', marginTop: '5px' }}>{item.label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                </div>
                <div className="span6">
                    <section className="social-box social-bordered">
                        <header className="header">
                            <h4><i className="icon-bar-chart" /> Biểu đồ theo tháng</h4>
                        </header>
                        <div className="body" style={{ padding: '15px' }}>
                            <div style={{ height: '250px', display: 'flex', alignItems: 'flex-end', gap: '5px' }}>
                                {stats.visitsPerMonthInYear && stats.visitsPerMonthInYear.map(item => (
                                    <div
                                        key={item.label}
                                        onMouseEnter={() => setHoveredMonth(item.label)}
                                        onMouseLeave={() => setHoveredMonth(null)}
                                        style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', position: 'relative' }}
                                    >
                                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', width: '100%', position: 'relative' }} title={`Tháng ${item.label.replace('T', '')}: ${item.value}`}>
                                            {hoveredMonth === item.label && (
                                                <div style={{
                                                    position: 'absolute',
                                                    bottom: `${(item.value / maxMonthValue) * 100}%`,
                                                    width: '100%',
                                                    textAlign: 'center',
                                                    fontSize: '11px',
                                                    fontWeight: 'bold',
                                                    marginBottom: '2px',
                                                    color: '#2891cf',
                                                    pointerEvents: 'none'
                                                }}>
                                                    {item.value}
                                                </div>
                                            )}
                                            <div style={{ height: `${(item.value / maxMonthValue) * 100}%`, width: '100%', backgroundColor: '#2891cf', minHeight: '1px' }}></div>
                                        </div>
                                        <span style={{ fontSize: '10px', marginTop: '5px' }}>{item.label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default AdminHomePage;